/** Keep this prompt aligned with the tested static subset in svg.ts. */
export const SVG_GENERATION_PROMPT = `Create a clean, professional SVG map symbol depicting [DESCRIBE SYMBOL].

IMPORTANT: Create an actual downloadable SVG file named map_symbol.svg, not merely SVG code displayed in your response.

Use your available file-creation tools to save the complete SVG markup into a UTF-8 .svg file and provide a download link or file attachment.

Do not substitute a PNG or other raster image.

SVG REQUIREMENTS:

- Set width="64", height="64" and viewBox="0 0 64 64".
- Use a transparent background.
- Include xmlns="http://www.w3.org/2000/svg". An optional title and accessibility labels are fine.
- Use simple static paths, rectangles, rounded rectangles, circles, ellipses, lines, polylines or polygons.
- Groups and static translate, scale, rotate, matrix or skew transforms are supported.
- Use explicit solid fill and stroke colours, including fill="none" when appropriate.
- Do not use scripts, event handlers, animation, external resources, embedded images, linked fonts, text elements, CSS stylesheets, filters, gradients, masks, clip paths, patterns, defs/use references, embedded HTML or foreignObject. Convert lettering to simple paths.
- Keep the artwork self-contained.
- Make the symbol bold, balanced and legible at 16–24 pixels.
- Avoid extremely thin strokes or tiny details.
- Keep the artwork within its viewBox.
- Do not add a background circle or square unless explicitly requested. Placeio can add its own backing shape.
- For a symbol that can be recoloured in Placeio, use one effective artwork colour and transparency.
- Multicolour artwork is also allowed, but generally retains its original colours.

DELIVERABLE:

A real, valid, downloadable SVG file that I can import directly into Placeio Maps.

Do not simply print the SVG markup.

If you cannot create files, explain that limitation and provide the complete valid SVG markup as a fallback that I can save manually as a UTF-8 file with the .svg extension.`;
